interface Props {
  footer?: string
}

export function Footer({ footer }: Props) {
  return footer ? <footer dangerouslySetInnerHTML={{ __html: footer }} /> : null
}
